const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://apicabaza.creago.be/rest/cabaza';
const DEFAULT_API_KEY = 'cabaza_api_key_2024_change_me';

function headers() {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': DEFAULT_API_KEY
    };
}

export const askQuestion = async ({ question, language = 'fr', userUuid = '' }) => {
    const res = await fetch(`${API_BASE_URL}/help/ask`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ question, language, userUuid })
    });
    const data = await res.json();
    if (!res.ok && !data.success && !data.SUCCESS) {
        throw new Error(data.message || `HTTP ${res.status}`);
    }
    return data.data || data.DATA || {};
};

export const rateAnswer = async (logUuid, rating) => {
    const res = await fetch(`${API_BASE_URL}/help/questions-log/${logUuid}/rate`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ rating })
    });
    return res.json();
};

export const getNudgeForEvent = async (event, userUuid = '', lang = 'fr') => {
    const qs = new URLSearchParams({ event, userUuid, lang });
    const res = await fetch(`${API_BASE_URL}/help/nudges/for-event?${qs.toString()}`, {
        method: 'GET',
        headers: headers()
    });
    const data = await res.json();
    const payload = data.data || data.DATA || {};
    // API renvoie {nudge: ""} quand rien
    if (!payload || !payload.uuid) return null;
    return payload;
};

export const dismissNudge = async (uuid, userUuid, actionTaken = false) => {
    const res = await fetch(`${API_BASE_URL}/help/nudges/${uuid}/dismiss`, {
        method: 'POST',
        headers: headers(),
        body: JSON.stringify({ userUuid, actionTaken })
    });
    return res.json();
};
